//
interface SortData {
  variableId: number | null | undefined
  id: number | null | undefined
}

function sortingCriteria(variableId: number, id: number): string {
  const supplementCriteria = id ? 'b' : 'c'

  return variableId > 0 ? 'a' : supplementCriteria
}

export default function sortSupplements(supplement1: SortData, supplement2: SortData) {
  const variableId1 = supplement1.variableId || 0
  const supplementId1 = supplement1.id || 0
  const variableId2 = supplement2.variableId || 0
  const supplementId2 = supplement2.id || 0

  const combinedId1 = `${sortingCriteria(
    variableId1,
    supplementId1
  )}${supplementId1}-${variableId1}`

  const combinedId2 = `${sortingCriteria(
    variableId2,
    supplementId2
  )}${supplementId2}-${variableId2}`

  if (combinedId1 < combinedId2) return -1

  if (combinedId1 > combinedId2) return 1

  return 0
}
